//工单信息-会员信息
import useTimer from '@/hooks/useTimer';
import { forwardRef, useImperativeHandle } from 'react';
import style from '../index.less';

interface Props {
    ref?: any;
}

const Timer: React.FC<Props> = forwardRef((props, ref) => {
    const { time, resetTimer, pause, recordAndReset, regain } = useTimer({
        resetDuration: process.env.UMI_ENV === 'test' ? 2 : 24,
    });

    useImperativeHandle(ref, () => {
        return {
            resetTimer,
            pause,
            recordAndReset,
            regain,
        };
    });

    return <div className={style.overtime}>{time}</div>;
});

export default Timer;
